/* eslint-disable @typescript-eslint/no-this-alias */
import React from 'react';
import PackageProductForm from './PackageProductForm.jsx';
import ConfigureFormCalendar from './ConfigureFormCalendar.jsx';
import { withTranslation } from 'react-i18next';

class ConfigurePackageFormComponent extends React.Component {
    constructor(props) {
        super(props);

        this.devisInputProductLabel = $('#products_product_label_'+this.props.index);
        const global = $('.products_global[data-index="'+this.props.index+'"]').val();

        let products_packages = this.getFormPackageData();
        let has_meeting_room = this.hasMeetingRoom(products_packages);
        this.nbLoaded = {};
        this.state = {
            isLoaded : false,
            all_dispositions: [],
            all_dispositions_loaded: false,
            all_locations: [],
            all_locations_loaded: false,
            product_title: this.devisInputProductLabel.val(),
            products_packages: products_packages,
            package_has_meeting_room: has_meeting_room,
            global:  global,
            configured: false
        };
        this.modalSelector = '.configure_product[data-index="'+this.props.index+'"]';
        this.priceFieldname = $('#price_type').length>0 && $('#price_type').prop('checked') ? 'price_ttc' : 'price_ht';
    }

    componentDidMount() {
        let url = ENV.base_lang_url+"myspace/providers//ajaxGetter/get_meeting_rooms_types";
        fetch(url, { 
            method: 'POST',
            headers:  { "Content-Type": "application/x-www-form-urlencoded" }
        })
        .then(rtn => rtn.json())
        .then(result => {
            this.setState({
                all_dispositions: result,
                all_dispositions_loaded: true
            });
        });

        let url_locations = ENV.base_lang_url+"myspace/providers//ajaxGetter/get_locations_and_groups_by_hotel";
        const params = new URLSearchParams();
        params.append('hotels_id', this.props.hotels_id);
        fetch(url_locations, { 
            method: 'POST',
            headers:  { "Content-Type": "application/x-www-form-urlencoded" },
            body: params.toString()
        })
        .then(rtn => rtn.json())
        .then(result => {
            this.setState({
                all_locations: result,
                all_locations_loaded: true
            });
        })
    }

    getFormPackageData() {
        let products_packages = {};
        let _this = this;
        $(`[name^="products[${this.props.index}][products_packages]"]`).each(function() {
            if ( !/products\[(?:[0-9]+|new_[a-z0-9]+)\]\[products_packages\]\[([0-9]+)\]\[[a-z_]+\](?:\[[a-z_]+\]+)?/.test($(this).attr('name')) ) return true;
            var index   = $(this).attr('name').replace(/products\[(?:[0-9]+|new_[a-z0-9]+)\]\[products_packages\]\[([0-9]+)\]\[[a-z_]+\](?:\[[a-z_]+\]+)?/ig, '$1');
            var key     = $(this).attr('name').replace(/products\[(?:[0-9]+|new_[a-z0-9]+)\]\[products_packages\]\[[0-9]+\]\[([a-z_]+)\](?:\[[a-z_]+\]+)?/ig, '$1');
            var value   = $(this).val();
            if ( 'undefined' == typeof(products_packages[`${_this.props.index}_${index}`]) ) products_packages[`${_this.props.index}_${index}`] = {};
            products_packages[`${_this.props.index}_${index}`][key] = value;
        });

        $(`[name^="products_type[${this.props.index}][products_packages]"]`).each(function() {
            if ( !/products_type\[(?:[0-9]+|new_[a-z0-9]+)\]\[products_packages\]\[([0-9]+)\]\[[a-z_]+\](?:\[[a-z_]+\]+)?/i.test($(this).attr('name')) ) return true;
            var index   = $(this).attr('name').replace(/products_type\[(?:[0-9]+|new_[a-z0-9]+)\]\[products_packages\]\[([0-9]+)\]\[[a-z_]+\](?:\[[a-z_]+\]+)?/ig, '$1');
            var key     = $(this).attr('name').replace(/products_type\[(?:[0-9]+|new_[a-z0-9]+)\]\[products_packages\]\[[0-9]+\]\[([a-z_]+)\](?:\[[a-z_]+\]+)?/ig, '$1');
            var value   = $(this).val();
            if ( 'undefined' == typeof(products_packages[`${_this.props.index}_${index}`]) ) products_packages[`${_this.props.index}_${index}`] = {};
            products_packages[`${_this.props.index}_${index}`][key] = value;
        });

        $(`[name^="products_locations[${this.props.index}][products_packages]"]`).each(function() {
            if ( !/products_locations\[(?:[0-9]+|new_[a-z0-9]+)\]\[products_packages\]\[([0-9]+)\]\[[a-z_]+\](?:\[[a-z_]+\]+)?/i.test($(this).attr('name')) ) return true;
            var index   = $(this).attr('name').replace(/products_locations\[(?:[0-9]+|new_[a-z0-9]+)\]\[products_packages\]\[([0-9]+)\]\[[a-z_]+\](?:\[[a-z_]+\]+)?/ig, '$1');
            var key     = $(this).attr('name').replace(/products_locations\[(?:[0-9]+|new_[a-z0-9]+)\]\[products_packages\]\[[0-9]+\]\[([a-z_]+)\](?:\[[a-z_]+\]+)?/ig, '$1');
            var value   = $(this).val();
            if ( 'undefined' == typeof(products_packages[`${_this.props.index}_${index}`]) ) products_packages[`${_this.props.index}_${index}`] = {};
            products_packages[`${_this.props.index}_${index}`][key] = value;
        });

        $(`[name^="products_details[${this.props.index}][products_packages]"]`).each(function() {
            if ( !/products_details\[(?:[0-9]+|new_[a-z0-9]+)\]\[products_packages\]\[([0-9]+)\]\[(price_ht|price_ttc|date_shift|hour_start|hour_end)\]/i.test($(this).attr('name')) ) return true;
            var index   = $(this).attr('name').replace(/products_details\[(?:[0-9]+|new_[a-z0-9]+)\]\[products_packages\]\[([0-9]+)\]\[(price_ht|price_ttc|date_shift|hour_start|hour_end)\]/ig, '$1');
            var key     = $(this).attr('name').replace(/products_details\[(?:[0-9]+|new_[a-z0-9]+)\]\[products_packages\]\[[0-9]+\]\[(price_ht|price_ttc|date_shift|hour_start|hour_end)\]/ig, '$1');
            var value   = $(this).val();
            if ( 'undefined' == typeof(products_packages[`${_this.props.index}_${index}`]) ) products_packages[`${_this.props.index}_${index}`] = {};
            products_packages[`${_this.props.index}_${index}`][key] = value;
        });
        return products_packages;
    }

    handleChangeProduct = (rtn) => {
        if(rtn.loaded) {
            let products_packages = Object.assign({}, this.state.products_packages);
            let old_product = products_packages[rtn.index];
            products_packages[rtn.index] = rtn.product;
            this.nbLoaded[rtn.index] = true;
            let nbProducts = Object.entries(products_packages).length;

            let modified = JSON.stringify(old_product) != JSON.stringify(rtn.product);
            let configured = false;
            if(this.state.package_has_meeting_room == "1") {
                for(const [i,pp] of Object.entries(products_packages)) {
                    configured |= (pp.products_type_slug == 'meeting-room' && pp.locations_id != "" && pp.hour_start != "");
                }
            }

            this.setState({
                products_packages: products_packages,
                isLoaded : Object.entries(this.nbLoaded).length == nbProducts,
                configured: configured
            }, () => {
                if(modified) {
                    this.handleSubmit();
                }
            });
        }
        
    }

    handleSubmit = () => {
        if(this.state.isLoaded && this.state.all_dispositions.length > 0) {
            Object.keys(this.state.products_packages).map((key) => {
                let product = this.state.products_packages[key];

                $(`.products_locations_hour_start[data-index="${key}"]`).val(product.hour_start);
                $(`.products_locations_hour_end[data-index="${key}"]`).val(product.hour_end);
                $(`.products_locations_pax[data-index="${key}"]`).val(product.pax).trigger('change');
                $(`.products_locations_meeting_rooms_type_slug[data-index="${key}"]`).val(product.meeting_rooms_type_slug);
                $(`.products_locations_locations_id[data-index="${key}"]`).val(product.locations_id);

                $(`.products_details_date_shift[data-index="${key}"]`).val(product.date_shift);

                $(`.products_qty_factor_parent[data-index="${key}"]`).val(product.qty_factor_parent);
                $(`.products_qty_factor_child[data-index="${key}"]`).val(product.qty_factor_child);
         
                $(`.products_product_label[data-index="${key}"]`).val(product.product_label);
                $(`.products_product_description[data-index="${key}"]`).val(product.product_description);
                
                let price = product[this.priceFieldname];
                $(`.price_package[data-index="${key}"]`).val(price).trigger('change');
                
                $(`.products_details_initial_stock[data-index="${this.props.index}"]`).trigger('gcQuantityUpdated.quantity_per_day_changed');
                
            });

            if(this.state.package_has_meeting_room == "1") {
                let new_class = this.state.configured ? 'badge-gc-green' : 'badge-gc-orange';
                $('.link-configure-package[data-index="'+this.props.index+'"]').removeClass('badge-gc-green').removeClass('badge-gc-orange').addClass(new_class);
            }
        }
    }

    handleClose = () => {
        GLOBAL_NAV.close($('section[data-tag="providers-requests_hotels-configure_package"]'));
    }

    hasMeetingRoom(products_packages) {

        let has_meeting_room = false;
        for(const [i,pp] of Object.entries(products_packages)) {
            has_meeting_room |= (pp.products_type_slug == 'meeting-room');
        }
        return has_meeting_room;
    }

    

    render() {
        const { t: gctrad } = this.props;
        return (
            <div className="vh-100">
                <div className="px-4">
                    <div className="fixed-part sticky">
                        <div className="border-bottom mb-2 d-flex justify-content-between align-items-center">
                            <h2 className="text-gc-dark-blue m-0 pt-4 pb-2">{this.props.label_modal_header} <span className="content">{this.state.product_title}</span></h2>
                            {this.props.has_functions_sheets && <small className="badge badge-gc-orange mt-2 ml-2">{this.props.trad.alert_fiche_fonction}</small>}

                            {this.state.global && this.state.global == 1 && 
                                <small className="badge badge-gc-orange mt-2">{gctrad('Les salles ne peuvent être bloquées pour des produits hors dates')}</small> 
                            }

                            <div><button type="button" className="btn btn-orange text-white font-weight-bold" onClick={this.handleClose}>
                                {this.props.trad.label_close}
                            </button></div>

                        </div>
                    </div>


                    <div className="gc-form">
                        {
                            Object.keys(this.state.products_packages).map((key) =>
                            <PackageProductForm 
                                defaultProduct={this.state.products_packages[key]} 
                                index={key} 
                                key={key}
                                locations={this.state.all_locations} 
                                dispositions={this.state.all_dispositions} 
                                hotels_id={this.props.hotels_id}
                                devise={this.props.devise}
                                priceFieldname={this.priceFieldname}
                                onChange={this.handleChangeProduct}
                                all_dispositions_loaded={this.state.all_dispositions_loaded}
                                all_locations_loaded={this.state.all_locations_loaded}
                                has_functions_sheets={this.props.has_functions_sheets}
                                global={this.state.global}
                                >
                            </PackageProductForm>
                            )
                        }
                    </div>

                    {!this.props.has_functions_sheets && this.props.display_calendar && <div>
                        <ConfigureFormCalendar 
                            index={this.props.index}
                            date_start={this.props.date_start} 
                            products_packages={this.state.products_packages}
                            hotels_id={this.props.hotels_id}
                            requests_hotels_id={this.props.requests_hotels_id}
                            type="package"
                            parentLoaded={this.state.isLoaded}
                            base_current_url={this.props.base_current_url} 
                            >
                        </ConfigureFormCalendar>
                    </div>}
                </div>
            </div>
        )
    }
}

const ConfigurePackageForm = withTranslation()(ConfigurePackageFormComponent);
export default ConfigurePackageForm;

ConfigurePackageForm.defaultProps = {
    trad: TRAD.ConfigurePackageForm ?? {}
};